export default __webpack_public_path__ + "assets/aruba-flag.png";